<template>
  <va-create-layout>
    <proyects-form :title="title" :item="item"></proyects-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
